import {
    createRouter,
    createWebHistory,
    createWebHashHistory,
} from "vue-router";
import { getBasePath, getBasePathName } from "@/util/pathConfig";

const router = createRouter({
    history: createWebHistory(getBasePath()),
    routes: [{
            path: "/",
            name: "首页",
            component: () =>
                import ("../views/index.vue"),
        },
        {
            path: "/inquireRecord",
            name: "查询记录",
            component: () =>
                import ("../views/inquireRecord.vue"),
        },
        {
            path: "/record",
            name: "历史记录",
            component: () =>
                import ("../views/record.vue"),
        },
        {
            path: "/toPay",
            name: "收银台",
            component: () =>
                import ("../views/toPay.vue"),
        },
        {
            path: "/toSFPay",
            name: "司法收银台",
            component: () =>
                import ("../views/toSFPay.vue"),
        },
        {
            path: "/report",
            name: "背调报告",
            component: () =>
                import ("../views/report.vue"),
        },
        {
            path: "/judicial",
            name: "司法报告",
            component: () =>
                import ("../views/judicial.vue"),
        },
        {
            path: "/complain",
            name: "投诉建议",
            component: () =>
                import ("../views/complain.vue"),
        },
        {
            path: "/caseReport",
            name: "样例报告",
            component: () =>
                import ("../views/caseReport.vue"),
        },
        {
            path: "/organQuery",
            name: "机构查询",
            component: () =>
                import ("../views/organ/query.vue"),
        },
        {
            path: "/organResult",
            name: "机构报告",
            component: () =>
                import ("../views/organ/result.vue"),
        },
        {
            path: "/organResults",
            name: "机构报告结果",
            component: () =>
                import ("../views/organ/result_old.vue"),
        },
        {
            path: "/organInfo",
            name: "机构信息",
            component: () =>
                import ("../views/organ/info.vue"),
        },
        {
            path: "/specialInfo",
            name: "专业查询",
            component: () =>
                import ("../views/special/info.vue"),
            meta: {
                title: "个人风险背调",
            },
        },

        {
            path: "/specialTopay",
            name: "专业支付",
            component: () =>
                import ("../views/special/toPay.vue"),
            meta: {
                title: "个人风险背调",
            },
        },
        {
            path: "/specialResult",
            name: "专业报告",
            component: () =>
                import ("../views/special/result.vue"),
            meta: {
                title: "个人风险背调",
            },
        },
        {
            path: "/omniCheckInfo",
            name: "多维背调查询",
            component: () =>
                import ("../views/omniCheck/info.vue"),
            meta: {
                title: "多维背调",
            },
        },
        {
            path: "/omniCheckResult",
            name: "多维背调结果",
            component: () =>
                import ("../views/omniCheck/result.vue"),
            meta: {
                title: "多维背调",
            },
        },
        {
            path: "/judicialInfo",
            name: "司法查询",
            component: () =>
                import ("../views/judicial/info.vue"),
            meta: {
                title: "司法查询",
            },
        },
        {
            path: "/judicialResult",
            name: "司法查询结果",
            component: () =>
                import ("../views/judicial/result.vue"),
            meta: {
                title: "司法查询",
            },
        },
        {
            path: "/companyJudicialResult",
            name: "企业司法查询结果",
            component: () =>
                import ("../views/judicial/companyJudicialResult.vue"),
            meta: {
                title: "司法查询",
            },
        },
        {
            path: "/payTrans",
            name: "支付中",
            component: () =>
                import ("../views/payTrans.vue"),
        },
        {
            path: "/taxResult",
            name: "税务报告",
            component: () =>
                import ("../views/tax/result.vue"),
        },
        {
            path: "/taxGather",
            name: "税务采集",
            component: () =>
                import ("../views/tax/gather.vue"),
        },
        {
            path: "/taxQuery",
            name: "税务查询",
            component: () =>
                import ("../views/tax/query.vue"),
        },
        {
            path: "/taxInfo",
            name: "税务授权",
            component: () =>
                import ("../views/tax/info.vue"),
        },
        {
            path: "/taxRecord",
            name: "税务查询历史",
            component: () =>
                import ("../views/tax/record.vue"),
        },
        {
            path: "/taxList",
            name: "税务历史记录",
            component: () =>
                import ("../views/tax/list.vue"),
        },
        {
            path: "/marriageQuery",
            name: "婚恋查询",
            component: () =>
                import ("../views/marriage/info.vue"),
        },
        {
            path: "/marriageResult",
            name: "婚恋报告",
            component: () =>
                import ("../views/marriage/result.vue"),
        },
        {
            path: "/marriageInfo",
            name: "婚恋支付",
            component: () =>
                import ("../views/marriage/toPay.vue"),
        },
        {
            path: "/trans",
            name: "过渡页",
            component: () =>
                import ("../views/trans.vue"),
        },
        {
            path: "/cashier",
            name: "收银台",
            component: () =>
                import ("../views/cashier.vue"),
        },
        {
            path: "/car",
            name: "车辆",
            component: () =>
                import ("../views/car.vue"),
        },
        {
            path: "/carDetails",
            name: "详情",
            component: () =>
                import ("../views/carDetails.vue"),
        },
        {
            path: "/carList",
            name: "车辆列表",
            component: () =>
                import ("../views/carList.vue"),
        },
        {
            path: "/debtQuery",
            name: "债务查询",
            component: () =>
                import ("../views/debt/query.vue"),
        },
        {
            path: "/phoneCard",
            name: "号卡",
            component: () =>
                import ("../views/haoka/phoneCard.vue"),
        },
        {
            path: "/haokaQuery",
            name: "号卡查询",
            component: () =>
                import ("../views/haoka/query.vue"),
        },
        {
            path: "/haokaQuerylist",
            name: "订单信息",
            component: () =>
                import ("../views/haoka/querylist.vue"),
        },
        {
            path: "/haokaOrderDetails",
            name: "订单详情",
            component: () =>
                import ("../views/haoka/orderDetails.vue"),
        },
        {
            path: "/haokaReUpload",
            name: "重新上传身份证",
            component: () =>
                import ("../views/haoka/reUploadCard.vue"),
        },
        {
            path: "/haokaOrderSuccess",
            name: "订单成功",
            component: () =>
                import ("../views/haoka/orderSuccess.vue"),
        },
        {
            path: "/haokaShop",
            name: "号卡店铺",
            component: () =>
                import ("../views/haoka/shop.vue"),
        },
        {
            path: "/haokaShopPoster",
            name: "海报分享",
            component: () =>
                import ("../views/haoka/shopPoster.vue"),
        },
        {
            path: "/loanShop",
            name: "我的贷款超市",
            component: () =>
                import ("../views/loan/shop.vue"),
        },
        {
            path: "/removeFromShelves",
            name: "下架提醒",
            component: () =>
                import ("../views/loan/removeFromShelves.vue"),
        },
        {
            path: "/undercarriageHaoka",
            name: "号卡下架提醒",
            component: () =>
                import ("../views/haoka/undercarriageHaoka.vue"),
        },
        {
            path: "/loanApply",
            name: "贷款申请页",
            component: () =>
                import ("../views/loan/apply.vue"),
        },
    ],
});

router.beforeEach((to, from, next) => {
    // 处理基础路径没有尾部斜杠的情况，例如：/ybfb12_h5 -> /ybfb12_h5/
    if (typeof window !== 'undefined') {
        const pathname = window.location.pathname;
        const basePathName = getBasePathName();
        // 检查当前路径是否正好是基础路径但没有尾部斜杠
        if (pathname === `/${basePathName}`) {
            // 如果访问的路径正好是基础路径但没有尾部斜杠，重定向到带尾部斜杠的版本
            const search = window.location.search || '';
            const hash = window.location.hash || '';
            next(`${pathname}/${search}${hash}`);
            return;
        }
    }

    // //拦截跳转个人风险背调( 高级版) https://wen.aisuyuan.com
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "溯源百分百";
    }
    if (to.path === "/" && to.query.see_type === "phoneCard") {
        //正式
        next(
            `/phoneCard?source=${to.query.source}&see_type=${to.query.see_type}&product=${to.query.product}`
        );
    } else if (
        to.path === "/haokaOrderDetails" &&
        to.query.see_type === "phoneCard"
    ) {
        next(
            `/phoneCard?source=${to.query.source}&see_type=${to.query.see_type}&product=${to.query.product}`
        );
    }
    // 个人风险背调( 普通版)
    else if (to.path === "/" && to.query.see_type === "bigSpecialty") {
        next(`/organQuery?source=${to.query.source}&see_type=${to.query.see_type}`);
    }
    // 个人风险背调( 高级版)
    else if (to.path === "/" && to.query.see_type === "specialty") {
        next(
            `/specialInfo?source=${to.query.source}&see_type=${to.query.see_type}`
        );
    }
    // 多维背调
    else if (to.path === "/" && to.query.see_type === "omniCheck") {
        next(
            `/omniCheckInfo?source=${to.query.source}&see_type=${to.query.see_type}`
        );
    }
    //企业税票
    else if (to.path === "/" && to.query.see_type === "companyTax") {
        next(`/taxQuery?source=${to.query.source}&see_type=${to.query.see_type}`);
    }
    // 债优
    else if (to.path === "/" && to.query.see_type === "debt") {
        next(`/debtQuery?source=${to.query.source}&see_type=${to.query.see_type}`);
    }
    // 婚恋
    else if (to.path === "/" && to.query.see_type === "matrimony") {
        next(
            `/marriageQuery?source=${to.query.source}&see_type=${to.query.see_type}`
        );
    }
    // 个人司法
    else if (to.path === "/" && to.query.see_type === "judicial") {
        next(
            `/judicialInfo?source=${to.query.source}&see_type=${to.query.see_type}`
        );
    }
    // 企业司法
    else if (to.path === "/" && to.query.see_type == "companyJudicial") {
        next(
            `/judicialInfo?source=${to.query.source}&see_type=${to.query.see_type}`
        );
    } else {
        next();
    }

    // //拦截跳转个人风险背调( 高级版) https://xin.xxycx.com
    // if(to.path === '/' && to.query.see_type === "bigSpecialty"){
    // 	next(`/organQuery?source=${to.query.source}&see_type=${to.query.see_type}`)
    // }else if(to.path === '/' && to.query.see_type === "specialty"){
    // 	next(`/specialInfo?source=${to.query.source}&see_type=${to.query.see_type}`)
    // }else {
    // 	next()
    // }
});

export default router;